import React from 'react';
import { Link } from '@inertiajs/react';
import { NAV_LINKS } from '../types';
import { SocialIcon } from './SocialIcon';
import { socialLinks, directContactInfo } from '../data/contact';
import { Mail, MapPin } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import logo from '../../assets/images/logo.jpeg';

const pageToPath = (page: string) => {
  if (page === 'Home') return '/';
  if (page === 'Support Us') return '/support';
  return `/${page.toLowerCase()}`;
};

const Footer: React.FC = () => {
  return (
    <footer className='bg-muted border-t border-border'>
      <div className='container mx-auto px-6 py-12'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8'>
          <div className='md:col-span-1'>
            <img src={logo} alt='Digital Wave Africa' className='h-12 w-auto mb-3' />
            <p className='text-muted-foreground text-sm'>Empowering the next generation with digital skills.</p>
            <div className='flex space-x-4 mt-4'>
              {socialLinks.map((social) => (
                <SocialIcon key={social.name} ariaLabel={`Follow us on ${social.name}`} href={social.href}>
                  <social.icon className='w-6 h-6' />
                </SocialIcon>
              ))}
            </div>
          </div>
          <div>
            <h3 className='text-foreground font-semibold mb-4'>Navigate</h3>
            <ul className='space-y-2'>
              {NAV_LINKS.map((link) => (
                <li key={link.name}>
                  <Link
                    href={pageToPath(link.name)}
                    className='text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:underline'
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className='text-foreground font-semibold mb-4'>Contact Us</h3>
            <ul className='space-y-3 text-muted-foreground'>
              {directContactInfo.map((item) => (
                <li key={item.name} className='flex items-center space-x-3'>
                  <item.icon className='h-5 w-5 shrink-0 text-primary' />
                  <a
                    href={item.href}
                    className='hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-ring rounded-sm px-1'
                  >
                    {item.value}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className='text-foreground font-semibold mb-4'>Newsletter</h3>
            <p className='text-muted-foreground text-sm mb-3'>Stay updated with our latest programs and events.</p>
            <form className='flex flex-col space-y-2 lg:flex-row lg:space-y-0'>
              <input
                type='email'
                placeholder='Your email'
                aria-label='Email address for newsletter'
                className='bg-background border border-border text-foreground rounded-md lg:rounded-l-md lg:rounded-r-none px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-ring'
              />
              <button
                type='submit'
                className='bg-primary text-primary-foreground font-semibold px-4 py-2 rounded-md lg:rounded-r-md lg:rounded-l-none hover:bg-primary/90 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2'
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
        <div className='mt-12 border-t border-border pt-6 text-center text-sm text-muted-foreground'>
          <p>&copy; {new Date().getFullYear()} Digital Wave Africa. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
